import { render, staticRenderFns } from "./ProposalList.vue?vue&type=template&id=0a4cb14f&"
import script from "./ProposalList.vue?vue&type=script&lang=js&"
export * from "./ProposalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports